import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { CountryProvider } from "./context/CountryContext";
import { BuyProvider } from "./components/BuyDialog";
import Hosting from "./pages/Hosting";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Home from "./pages/Home";
import Packages from "./pages/Packages";
import Domains from "./pages/Domains";
import Partners from "./pages/Partners";
import CustomerPortal from "./pages/CustomerPortal";
import SupplierPortal from "./pages/SupplierPortal";
import AdminPortal from "./pages/AdminPortal";
import { Login, Register } from "./pages/Auth";
import { PaymentSimulate, PaymentResult } from "./pages/Payment";
import WebsiteBuilder from "./pages/WebsiteBuilder";
import SiteEditor from "./pages/SiteEditor";
import PublicSite from "./pages/PublicSite";
import { useLocation } from "react-router-dom";

const Chrome = ({ children }) => {
  const { pathname } = useLocation();
  const bare = pathname.startsWith("/s/");
  return <>{!bare && <Header />}<main>{children}</main>{!bare && <Footer />}</>;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CountryProvider>
            <BuyProvider>
              <Chrome>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/internet/:type" element={<Packages />} />
                  <Route path="/domains" element={<Domains />} />
                  <Route path="/cart" element={<Navigate to="/" replace />} />
                  <Route path="/hosting" element={<Hosting />} />
                  <Route path="/partners" element={<Partners />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/payment/simulate" element={<ProtectedRoute><PaymentSimulate /></ProtectedRoute>} />
                  <Route path="/payment/result" element={<PaymentResult />} />
                  <Route path="/portal" element={<ProtectedRoute roles={["customer"]}><CustomerPortal /></ProtectedRoute>} />
                  <Route path="/supplier" element={<ProtectedRoute roles={["supplier"]}><SupplierPortal /></ProtectedRoute>} />
                  <Route path="/website-builder" element={<WebsiteBuilder />} />
                  <Route path="/website-builder/:id" element={<ProtectedRoute><SiteEditor /></ProtectedRoute>} />
                  <Route path="/s/:slug" element={<PublicSite />} />
                  <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminPortal /></ProtectedRoute>} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Chrome>
              <Toaster position="top-center" richColors />
            </BuyProvider>
          </CountryProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
